import makeStyles from '@mui/styles/makeStyles';
import Button, { ButtonProps } from '@mui/material/Button';
import type { Theme } from '@mui/material/styles';

import { CustomOrganizationIcon } from '@experimental-components/IconsComponents/CustomIcons';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    height: '100%',
    paddingInline: theme.spacing(3),
    fontSize: 16,
  },
  startIcon: {
    paddingRight: theme.spacing(1),
  },
}));

interface Props extends ButtonProps {
  customIcon?: React.ReactNode;
}

function ButtonNav({ customIcon, ...others }: Props) {
  const classes = useStyles();
  return (
    <Button
      classes={{ root: classes.root, startIcon: classes.startIcon }}
      {...others}
      startIcon={customIcon || <CustomOrganizationIcon />}
    />
  );
}

export default ButtonNav;
